import { initialState } from "./state"

export const setPodcastsAnalytics = (state, payload) => {
  state.podcastsAnalytics = payload
}

export const setSelectedPodcasts = (state, payload) => {
  state.selectedPodcasts = payload
}

export const setPeriod = (state, payload) => {
  state.period = payload
}

export const reset = (state) => {
  const s = initialState()

  Object.keys(s).forEach((key) => {
    state[key] = s[key]
  })
}
